import './components/jquery';
import './components/mask';
import './components/menu-nav';
import './components/lgpd';
import './components/rangeInputs';
import './components/swiper';
import './components/wow-init';
import './components/fancybox';
import './components/video';
